import S3ContentLoader from '../s3ContentLoader'
import { useState } from 'react'
import classes from './PageHeader.module.scss'
import cn from 'clsx'

interface Props {
  bucket: string
  s3FileName?: string
  defaultS3FileName?: string
  isHold: boolean
  enableHide?: boolean
  staticHtml?: string
}

export default function PageHeader({
  bucket,
  s3FileName,
  defaultS3FileName = 'default',
  isHold = true,
  enableHide = true,
  staticHtml
}: Props) {
  const [showShortText, setShowShortText] = useState(true)

  const getShowMore = () => {
    if (!enableHide) {
      return null
    }
    return (
      <div
        onClick={() => {
          setShowShortText(!showShortText)
        }}
        className="flex items-center	cursor-pointer	flex-col">
        {!showShortText && <span className={classes.upArrow}></span>}
        <button className="relative text-white  shadow-none font-bold text-[16px]">
          {showShortText ? 'Read More' : 'Show Less'}
        </button>
        {showShortText && <span className={classes.downArrow}></span>}
      </div>
    )
  }

  const className = cn(
    'text-white z-0  overflow-hidden max-w-[1180px]  flex align-center',
    {
      [classes.limitTextHeight]: showShortText && enableHide
    }
  )
  return (
    <section>
      <div
        className={`info-box-ctr py-[10px] px-[20px] items-center text-center align-center justify-center ${classes.infoBox} !bg-[url('../public/assets/img/Hero_Background.webp')]`}>
        {staticHtml ? (
          <div
            className={className}
            dangerouslySetInnerHTML={{
              __html: staticHtml
            }}></div>
        ) : (
          !isHold && (
            <S3ContentLoader
              bucket={bucket}
              s3FileName={s3FileName}
              defaultS3FileName={defaultS3FileName}
              className={className}
            />
          )
        )}
        {getShowMore()}
      </div>
    </section>
  )
}
